module.exports = __webpack_public_path__ + "img/2f_l_yanagi.e97b6a5c.jpg";